import {WishlistEvents} from "@flashpointbv/solar-datalayer/src";

declare global {
  interface Window {
    dataLayer: Array<object>;
  }
}

import {SolarDataLayer} from "@flashpointbv/solar-datalayer/dist";

export class ExtendedDataLayer extends SolarDataLayer {
  addViewStoreStock(product: object): void {
    SolarDataLayer.resetDataLayer();
    let extraOptions = {};

    if (product['product_type'] === 'bundle' && Object.prototype.hasOwnProperty.call(product, 'bundle_options')) {
      let items: Array<object> = [];

      product['bundle_options'].forEach((bundleProduct: object) => {
        items.push(ExtendedDataLayer.defaultProductInformation(bundleProduct));
      });
    }

    window.dataLayer.push({
      'event': 'view_store_stock',
      'ecommerce': {
        'currency': SolarDataLayer.currency,
        'items': [{
          ...ExtendedDataLayer.defaultProductInformation(product),
        }]
      }
    });
  }
  addNewsLetterSignUp(): void {
    window.dataLayer.push({
      'event': 'newsletter_signup'
    })
  }
  addViewWishlist(products: Array<object>, listType?: string, index: number = 0): void {
    if ( ! window.dataLayer.filter(e => e['event'] === 'view_wishlist').length) {
      SolarDataLayer.resetDataLayer();
    }

    let items: Array<object> = [];

    products.forEach((product: object) => {
      items.push(ExtendedDataLayer.defaultProductInformation(product));
    });

    window.dataLayer.push({
      'event': 'view_wishlist',
      'ecommerce': {
        'items': items
      }
    });
  }

  addContactFormInteraction(field: string, valid: boolean = false, value: string = ''): void {
    const data = {
      'event' : 'contact_form_interaction',
      'field' : field,
    }
    if(['firstname', 'lastname', 'email', 'phone'].includes(field)) {
      data['valid'] = valid;
    } else{
      data['value'] = value;
    }
    window.dataLayer.push(data);
  }
  addContactFormSend(subject:string, store:string){
    window.dataLayer.push({
      'event' : 'contact_form_send',
      'valid' : true, //submit is always true
      'value' : subject,
      'store' : store,
    });
  }

  override addViewItemsList(products: Array<object>, listType?: string, index: number = 0): void {
    if ( ! window.dataLayer.filter(e => e['event'] === 'view_item_list').length) {
      SolarDataLayer.resetDataLayer();
    }

    let items: Array<object> = [];

    products.forEach((product: object) => {
      index++;

      const productData = {
        'item_list_id': listType.replace(/ /g, '_').toLowerCase(),
        'item_list_name': listType,
        'index': index,
      };

      items.push(Object.assign({}, productData, ExtendedDataLayer.defaultProductInformation(product)));
    });

    window.dataLayer.push({
      'event': 'view_item_list',
      'ecommerce': {
        'items': items
      }
    });
  }

  override addAddToWishlist(product: object, event: WishlistEvents = WishlistEvents.ADD): void {
    SolarDataLayer.resetDataLayer();

    window.dataLayer.push({
      'event': event,
      'ecommerce': {
        'items': ExtendedDataLayer.defaultProductInformation(product)
      }
    });
  }

  static override defaultProductInformation(product: object): object {
    const config = SolarDataLayer.config;

    const productData = {
      'item_name': SolarDataLayer.dataLayerValue(product[config['item_name']]),
      'item_id': SolarDataLayer.dataLayerValue(product[config['item_id']]),
      'item_group_id': SolarDataLayer.dataLayerValue(product[config['item_group_id']]),
      'item_brand': SolarDataLayer.dataLayerValue(product[config['item_brand']]),
      'item_variant': SolarDataLayer.dataLayerValue(product[config['item_variant']]),
      'currency': SolarDataLayer.currency,
      'price': SolarDataLayer.dataLayerValue(SolarDataLayer.formatPrice(product[config['price']])),
      'quantity': 1,
      'discount': SolarDataLayer.getSalePrice(SolarDataLayer.formatPrice(product[config['old_price']]), SolarDataLayer.formatPrice(product[config['price']]))
    };

    let categoryData = {};
    for (let i = 0; i < 5; i++) {
      categoryData[`item_category${i > 0 ? i + 1 : ''}`] = SolarDataLayer.resolveCategory(Object.prototype.hasOwnProperty.call(product, config['item_categories']) ? product[config['item_categories']] : [], i);
    }

    return {
      ...productData,
      ...categoryData
    };
  }
}
